import { carouselData } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-2">精选专题策划，发现更多精彩电视剧内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="group relative bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-lg md:text-xl font-semibold text-white">{item.title}</h3>
                  <p className="text-sm text-white/80 mt-1">{item.subtitle}</p>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}